<template>
    <li class="btn" v-bind:class="{'is-selected': internalSelected}" @click="setSelected">
            {{moment(item.start_datetime).format('LT')}} to {{moment(item.end_datetime).format('LT')}}
    </li>
</template>

<script>
export default {
    name: 'SessionSelectItem',
    props: ['index', 'selected', 'item'],
    methods: {
        setSelected() {
            this.$emit('selected', this.index);
        }
    },
    computed: {
        internalSelected() {
            return this.selected;
        }
    }
}
</script>

<style>

</style>
